var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('div',{staticClass:"recent-activity-widget__items"},_vm._l((_vm.value),function(item,index){return _c(item.typename,{key:index,tag:"component",attrs:{"value":item}})}),1):_c('EmptyState',{staticClass:"grow-1 mb-2",attrs:{"title":_vm.$t('noActivity'),"icon":['fal', 'bolt']}})
}
var staticRenderFns = []

export { render, staticRenderFns }